// extracted by mini-css-extract-plugin
export var chevronIcon = "_4v-2";
export var teamName = "_4v-1";
export var teamSwitcherButton = "_4v-0";